/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Wrapuptimepercent3Inputs */

const en_entity_wrapuptimepercent3 = /** @type {(inputs: Entity_Wrapuptimepercent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wrap-Up Time Percent`)
};

const de_entity_wrapuptimepercent3 = /** @type {(inputs: Entity_Wrapuptimepercent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachbearbeitungszeit Prozent`)
};

/**
* | output |
* | --- |
* | "Wrap-Up Time Percent" |
*
* @param {Entity_Wrapuptimepercent3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_wrapuptimepercent3 = /** @type {((inputs?: Entity_Wrapuptimepercent3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Wrapuptimepercent3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_wrapuptimepercent3(inputs)
	return de_entity_wrapuptimepercent3(inputs)
});
export { entity_wrapuptimepercent3 as "entity_wrapUpTimePercent" }